import {
  AdminFeed,
  AdminQuestoes,
  AdminBonus,
  AdminDesafios,
  AdminAlunos,
  AdminProfessores,
  AdminCasas,
  AdminGruposAcesso,
  AdminAtividades,
  AdminMeritos,
  AdminAgendamentos,
  AdminCardapio,
  AdminConteudos,
  AdminVestibulares,
  AdminSimuladoresConteudo,
  AdminOlimpiadaConteudo,
} from "./pages";
import { InstitutionReportPage } from "./pages/RelatorioInstitucional/index.jsx";
import React from "react";
export default function AdminPanel(props) {
  const requested = props.adminAba || "relatorio";
  const aba = [
    "atividades",
    "bonus",
    "casas",
    "conteudos-adm",
    "grupos-acesso",
    "meritos-adm",
    "olimpiada-conteudo-adm",
    "relatorio",
    "simuladores-conteudo-adm",
    "vestibulares-adm",
  ].includes(requested)
    ? requested
    : "relatorio";
  return (
    <div className={"ct"}>
      <h1
        className={"pt"}
        style={{
          marginBottom: 18,
        }}
      >
        <em>
          {{
            relatorio: "Relatório",
            "feed-adm": "Feed",
            questoes: "Questões",
            bonus: "Bônus / Penalidade",
            "desafios-adm": "Desafios",
            alunos: "Alunos",
            professores: "Professores",
            casas: "Instituições",
            "grupos-acesso": "Grupos de Acesso",
            atividades: "Pontuação",
            "meritos-adm": "Méritos",
            "agendamentos-adm": "Agendamentos",
            "cardapio-adm": "Cardápio",
            "conteudos-adm": "Reforço",
            "vestibulares-adm": "Vestibulares",
            "simuladores-conteudo-adm": "Simuladores",
            "olimpiada-conteudo-adm": "Olimpíadas",
          }[aba] || "Admin"}
        </em>
      </h1>
      {"relatorio" === aba && <InstitutionReportPage />}
      {"feed-adm" === aba && (
        <AdminFeed
          {...{
            ...props,
          }}
        />
      )}
      {"questoes" === aba && (
        <AdminQuestoes
          {...{
            ...props,
          }}
        />
      )}
      {"bonus" === aba && (
        <AdminBonus
          {...{
            ...props,
          }}
        />
      )}
      {"desafios-adm" === aba && (
        <AdminDesafios
          {...{
            ...props,
          }}
        />
      )}
      {"alunos" === aba && (
        <AdminAlunos
          {...{
            ...props,
          }}
        />
      )}
      {"professores" === aba && (
        <AdminProfessores
          {...{
            ...props,
          }}
        />
      )}
      {"casas" === aba && (
        <AdminCasas
          {...{
            ...props,
          }}
        />
      )}
      {"grupos-acesso" === aba && (
        <AdminGruposAcesso
          {...{
            ...props,
          }}
        />
      )}
      {"atividades" === aba && (
        <AdminAtividades
          {...{
            ...props,
          }}
        />
      )}
      {"meritos-adm" === aba && (
        <AdminMeritos
          {...{
            ...props,
          }}
        />
      )}
      {"agendamentos-adm" === aba && (
        <AdminAgendamentos
          {...{
            ...props,
          }}
        />
      )}
      {"cardapio-adm" === aba && (
        <AdminCardapio
          {...{
            ...props,
          }}
        />
      )}
      {"conteudos-adm" === aba && (
        <AdminConteudos
          {...{
            ...props,
          }}
        />
      )}
      {"vestibulares-adm" === aba && (
        <AdminVestibulares
          {...{
            ...props,
          }}
        />
      )}
      {"simuladores-conteudo-adm" === aba && (
        <AdminSimuladoresConteudo
          {...{
            ...props,
            conteudos: props.simuladoresConteudo,
            setConteudos: props.setSimuladoresConteudo,
            addConteudoCategoria: props.addSimuladorCategoria,
            updateSimuladorCategoria: props.updateSimuladorCategoria,
            removeConteudoCategoria: props.removeSimuladorCategoria,
            restoreSimuladorCategoria: props.restoreSimuladorCategoria,
            addConteudoCurso: props.addSimuladorCurso,
            updateConteudoCurso: props.updateSimuladorCurso,
            removeConteudoCurso: props.removeSimuladorCurso,
            restoreConteudoCurso: props.restoreSimuladorCurso,
            addConteudoModulo: props.addSimuladorModulo,
            updateConteudoModulo: props.updateSimuladorModulo,
            removeConteudoModulo: props.removeSimuladorModulo,
            restoreConteudoModulo: props.restoreSimuladorModulo,
            addConteudoAula: props.addSimuladorAula,
            updateConteudoAula: props.updateSimuladorAula,
            removeConteudoAula: props.removeSimuladorAula,
            restoreConteudoAula: props.restoreSimuladorAula,
          }}
        />
      )}
      {"olimpiada-conteudo-adm" === aba && (
        <AdminOlimpiadaConteudo
          {...{
            ...props,
            conteudos: props.olimpiadaConteudo,
            setConteudos: props.setOlimpiadaConteudo,
            addConteudoCategoria: props.addOlimpiadaCategoria,
            updateSimuladorCategoria: props.updateOlimpiadaCategoria,
            removeConteudoCategoria: props.removeOlimpiadaCategoria,
            restoreSimuladorCategoria: props.restoreOlimpiadaCategoria,
            addConteudoCurso: props.addOlimpiadaCurso,
            updateConteudoCurso: props.updateOlimpiadaCurso,
            removeConteudoCurso: props.removeOlimpiadaCurso,
            restoreConteudoCurso: props.restoreOlimpiadaCurso,
            addConteudoModulo: props.addOlimpiadaModulo,
            updateConteudoModulo: props.updateOlimpiadaModulo,
            removeConteudoModulo: props.removeOlimpiadaModulo,
            restoreConteudoModulo: props.restoreOlimpiadaModulo,
            addConteudoAula: props.addOlimpiadaAula,
            updateConteudoAula: props.updateOlimpiadaAula,
            removeConteudoAula: props.removeOlimpiadaAula,
            restoreConteudoAula: props.restoreOlimpiadaAula,
          }}
        />
      )}
    </div>
  );
}
